import React, { useState } from "react";
import "../styles/Projects.css";

// Preview images are named by filename in data.json; a missing file renders nothing instead of crashing.
const resolveImage = (fileName) => {
  try {
    return require(`../assets/img/${fileName}`);
  } catch {
    return undefined;
  }
};

const Projects = ({ projects, section = {} }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredProjects = (projects || []).filter((project) =>
    project.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Project type icons based on keywords
  const getProjectIcon = (title) => {
    const titleLower = title.toLowerCase();
    if (titleLower.includes("poker") || titleLower.includes("game") || titleLower.includes("invader")) {
      return "fas fa-gamepad";
    } else if (titleLower.includes("kaggle") || titleLower.includes("prediction")) {
      return "fas fa-brain";
    } else if (titleLower.includes("sudoku") || titleLower.includes("solver")) {
      return "fas fa-puzzle-piece";
    } else if (titleLower.includes("step") || titleLower.includes("track")) {
      return "fas fa-shoe-prints";
    } else if (titleLower.includes("eagle") || titleLower.includes("vision")) {
      return "fas fa-eye";
    }
    return "fas fa-code";
  };

  // Featured projects span the full timeline; the rest alternate sides among themselves
  let sideIndex = 0;
  const getItemClass = (project) => {
    if (project.featured) {
      return "projects__item projects__item--featured";
    }
    return `projects__item ${sideIndex++ % 2 === 0 ? "left" : "right"}`;
  };

  return (
    <section
      id="projects"
      className="projects section wow animate__animated animate__fadeInUp"
    >
      <span className="section__subtitle">{section.subtitle}</span>
      <h2 className="section__title">{section.title}</h2>

      <div className="projects__search">
        <div className="projects__search-wrapper">
          <i className="fas fa-search projects__search-icon"></i>
          <input
            type="search"
            aria-label="Search projects"
            placeholder="Search projects..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="projects__search-input"
          />
        </div>
      </div>

      <div className="projects__container">
        <div className="projects__timeline">
          {filteredProjects.map((project, index) => (
            <article key={project.title} className={getItemClass(project)}>
              <div className="projects__timeline-marker">
                <div className="projects__timeline-icon">
                  <i className={getProjectIcon(project.title)}></i>
                </div>
                {index !== filteredProjects.length - 1 && (
                  <div className="projects__timeline-line"></div>
                )}
              </div>

              <div className="projects__content">
                <div className="projects__header">
                  <h3 className="projects__title">{project.title}</h3>
                  <div className="projects__meta">
                    <span className="projects__date">
                      <i className="far fa-calendar-alt"></i>
                      {project.date}
                    </span>
                    {project.link && (
                      <a
                        href={project.link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="projects__link"
                      >
                        {project.link.label}
                        <i className="fas fa-external-link-alt" aria-hidden="true"></i>
                      </a>
                    )}
                  </div>
                </div>

                <ul className="projects__description">
                  {project.description.map((desc, idx) => (
                    <li key={idx} className="projects__description-item">
                      {desc}
                    </li>
                  ))}
                </ul>

                {project.previews?.length > 0 && (
                  <div className="projects__previews">
                    {project.previews.map((preview) => {
                      const src = resolveImage(preview.image);
                      return (
                        src && (
                          <img
                            key={preview.image}
                            src={src}
                            alt={preview.alt}
                            className="projects__preview"
                            loading="lazy"
                          />
                        )
                      );
                    })}
                  </div>
                )}
              </div>
            </article>
          ))}
        </div>

        {filteredProjects.length === 0 && (
          <p className="projects__no-results">
            No projects found matching "{searchTerm}"
          </p>
        )}
      </div>
    </section>
  );
};

export default Projects;
